<!-- <app-common-header></app-common-header> -->
<div class="abc">
<app-website-header></app-website-header>
<!-- <app-website-navbar></app-website-navbar> -->

<!-- body -->
<div class="my-container" style="min-height: 79vh; z-index: 99;
position: relative;">
    <router-outlet></router-outlet>
</div>
<!-- <app-common-footer></app-common-footer> -->
<app-website-footer></app-website-footer>
</div>